module.exports = __webpack_public_path__ + "img/progress@2x.765443f9.png";